import { GridColumnType } from "../../../data/gridColumnType";

export const BoardApprovalAssignmentConfig = {
  columns: [
    {
      name: "",
      fieldName: "select",
      allowShort: false,
      colType: GridColumnType.CHECKBOX,
      colSettings: {
        allowHeaderCheckbox: true,
        headerLabel: "Select All",
        allowEdit: true
      }
    },
    {
      name: "Company Name",
      fieldName: "companyName",
      allowShort: false,
      colType: GridColumnType.Text,
    },
    {
      name: "Organisation Profile",
      fieldName: "organisationProfile",
      allowShort: false,
      colType: GridColumnType.Text,
    },
    {
      name: "Organisation Category",
      fieldName: "organisationCategory",
      allowShort: false,
      colType: GridColumnType.Text,
    },
    {
      name: "Subscription Type",
      fieldName: "subscriptionType",
      allowShort: false,
      colType: GridColumnType.Text,
    },
    {
      name: "Application Type",
      fieldName: "applicationType",
      allowShort: false,
      colType: GridColumnType.Text,
    },
    {
      name: "Application Term",
      fieldName: "applicationTerm",
      allowShort: false,
      colType: GridColumnType.Text,
    },
    // {
    //   name: "Membership Tier",
    //   fieldName: "corporateMembershipTypeName",
    //   allowShort: false,
    //   colType: GridColumnType.Text,
    // },
    {
      name: "Submitted Date",
      fieldName: "createdAt",
      allowShort: false,
      colType: GridColumnType.DATE,
      colSettings: {
        format: 'DD MMM YYYY',
      }
    },
  ],
};
